import { render, staticRenderFns } from "./Modalx.vue?vue&type=template&id=51c6faca&scoped=true&"
import script from "./Modalx.vue?vue&type=script&lang=js&"
export * from "./Modalx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6faca",
  null
  
)

export default component.exports